/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../lib/@waca/dashboard-common/dist/core/Model'
], function(Model) {

	/**
	 * Model which represents a drill through definition entry
	 */
	var DrillThroughDefinitionEntry = Model.extend({

		whitelistAttrs: [
			'id',
			'name',
			'type',
			'assetId',
			'assetSearchPath',
			'scope',
			'modelRefs',
			'mappings',
			'ownerId',
			'perspective'
		],

		init: function(attrs) {
			DrillThroughDefinitionEntry.inherited('init', this, arguments);
			this.targetName = attrs.targetName;
			this.api = {
				getId: this._getId.bind(this),
				getName: this._getName.bind(this),
				getTargetName: this._getTargetName.bind(this),
				setTargetName: this._setTargetName.bind(this),
				getType: this._getType.bind(this),
				getAssetId: this._getAssetId.bind(this),
				setAssetId: this._setAssetId.bind(this),
				getAssetSearchPath: this._getAssetSearchPath.bind(this),
				setAssetSearchPath: this._setAssetSearchPath.bind(this),
				getPerspective: this._getPerspective.bind(this),
				setPerspective: this._setPerspective.bind(this),
				getScope: this._getScope.bind(this),
				getModelRefs: this._getModelRefs.bind(this),
				getMappings: this._getMappings.bind(this),
				update: this._update.bind(this),
				removeModelRef: this._removeModelRef.bind(this),
				getOwnerId: this._getOwnerId.bind(this)
			};
		},

		/**
		 * @returns the public api to the drill through model that is accessible to clients.
		 */
		getAPI: function() {
			return this.api;
		},

		_getId: function() {
			return this.id;
		},

		_getName: function() {
			return this.name;
		},

		_getType: function() {
			return this.type;
		},

		_getAssetId: function() {
			return this.assetId;
		},

		_setAssetId: function(assetId) {
			this.assetId = assetId;
		},

		_getPerspective: function() {
			return this.perspective || 'authoring';
		},

		_setPerspective: function(perspective) {
			this.perspective = perspective;
		},

		_getAssetSearchPath: function() {
			return this.assetSearchPath;
		},

		_setAssetSearchPath: function(assetSearchPath) {
			this.assetSearchPath = assetSearchPath;
		},

		_getTargetName: function() {
			return this.targetName;
		},

		_setTargetName: function(targetName) {
			this.targetName = targetName;
		},

		_getScope: function() {
			return this.scope;
		},

		_getModelRefs: function() {
			return this.modelRefs;
		},

		_getMappings: function() {
			return this.mappings;
		},

		_update: function(context, options) {
			this.set(context, options);
		},

		_removeModelRef: function(/* modelRef */) {},

		_getOwnerId: function() {
			return this.ownerId;
		}
	});

	return DrillThroughDefinitionEntry;
});
